import React from 'react';
import { Hero, TestimonialsHero } from './components/Hero';
import { PainSection, ProductOverview, TomosSection, WhatIncluded } from './components/Product';
import { BonusSection } from './components/Bonus';
import { UrgencySection, PricingSection, PackCompletoDetail, GuaranteeSection, ExtendedTestimonials } from './components/Pricing';
import { FAQSection, Footer } from './components/FAQ';
import { PurchasePopup } from './components/Shared';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-amber-200 selection:text-amber-900" data-id="element-0">
      <Hero data-id="element-1" />
      <TestimonialsHero data-id="element-2" />
      <PainSection data-id="element-3" />
      <ProductOverview data-id="element-4" />
      <TomosSection data-id="element-5" />
      <WhatIncluded data-id="element-6" />
      <BonusSection data-id="element-7" />
      <UrgencySection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <PackCompletoDetail data-id="element-10" />
      <ExtendedTestimonials data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchasePopup data-id="element-15" />
    </div>;
}